import { render, staticRenderFns } from "./LittleUserTeaser.vue?vue&type=template&id=76acbdd8&scoped=true&"
import script from "./LittleUserTeaser.vue?vue&type=script&lang=js&"
export * from "./LittleUserTeaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76acbdd8",
  null
  
)

export default component.exports